<template>
    <div :class="{ 'modal-table': inModal  }" class="table-wrapper">
        <h4 class="title" v-if="inModal">{{modalTitle}}</h4>
        <table v-if="auth" class="branches-table">
            <thead>
                <tr>
                    <th><b>Наименование</b></th>
                    <th><b>Адрес</b></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(e, i) in list" :key="i">
                    <td>{{e.name ? e.name : '—'}}</td>
                    <td>{{e.address ? e.address : '—'}}</td>
                </tr>
            </tbody>
        </table>
        <demo-message v-else />
    </div>
</template>

<script>
import demoMessage from '@/components/ui/demoMessage/demoMessage.vue'

export default {
    props: {
        list: Array,
        inModal: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'fns'
        }
    },
    components: {
        demoMessage
    },
    computed: {
        modalTitle() { return this.type === 'fns' ? 'По данным ФНС:' : 'По данным ГМЦ Росстата:' }
    }
}
</script>

<style lang="sass" scoped>
.branches-table
    border-collapse: collapse
    border-spacing: 0
    width: 100%
    margin-bottom: 15px
    font-size: 13px
    td
        vertical-align: top
        border: none
        font-size: 13px
        line-height: 18px
    td, th
        padding: 8px
        color: #444
        -webkit-text-size-adjust: 100
        text-align: left
.title
    font-size: 24px
    line-height: 30px
    margin: 0 0 15px 0
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif
    font-weight: 400
    color: #444
    text-transform: none
.modal-table
    td
        border-bottom: 1px solid #ddd
        font-size: 14px
        &:first-child
            width: 60%
</style>